//画像の置換
$(function(){
	var $setElem = $('.switch'),
	pcName = 'pc_',
	spName = 'sp_',
	replaceWidth = 767;

	$setElem.each(function(){
		var $this = $(this);
		function imgSize(){
			var windowWidth = window.innerWidth;
			if(windowWidth >= replaceWidth) {
				$this.attr('src',$this.attr('src').replace(spName,pcName)).css({visibility:'visible'});
			} else if(windowWidth < replaceWidth) {
				$this.attr('src',$this.attr('src').replace(pcName,spName)).css({visibility:'visible'});
			}
		}
		$(window).resize(function(){imgSize();});
		imgSize();
	});
});

// ページトップ
$(document).ready(function() {
	var pagetop = $('.pagetop');
	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			pagetop.fadeIn();
		} else {
			pagetop.fadeOut();
		}
	});
	pagetop.click(function () {
		$('body, html').animate({ scrollTop: 0 }, 500);
		return false;
	});
});


// スムーズスクロール
$(document).ready(function() {
	$('a').click(function(e){
		var anchor = $(this),
		href = anchor.attr('href'),
		pagename = window.location.href;
		pagename = pagename.replace(/#.*/,'');
		href = href.replace( pagename , '' );
		if( href.search(/^#/) >= 0 ){
			e.preventDefault();
			var speed = 400;
			var target = $(href == "#" || href == "" ? 'html' : href);
			var target= $(this).attr("href");
			var webkit = !document.uniqueID && !window.opera && !window.globalStorage && window.localStorage;
			$("html, body").animate({
				scrollTop: $(target).offset().top},400
			);
			return false;
		}
	});
});

